export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export const isArray = (value: unknown): value is any[] => value instanceof Array

export const hasKey = <O>(obj: O, key: keyof any): key is keyof O => key in obj
